import React from 'react';
import ChurnRatioCard from '../../components/dora/ChurnRatioCard';

export default function MemberChurnCardColumn({
  churnLoading,
  churnData,
  churnWindowDays,
  churnPeriod,
  churnChartType,
  setChurnPeriod,
  setChurnChartType,
}: any) {
  return (
    <div className="min-w-0 flex flex-col h-full">
      <ChurnRatioCard
        className="h-full flex flex-col"
        loading={churnLoading}
        noData={
          !churnData ||
          !churnData.dates?.length ||
          (churnData.ratios?.length > 0 && churnData.ratios.every((r) => r === 0))
        }
        dates={churnData?.dates}
        ratios={churnData?.ratios}
        windowDays={churnWindowDays}
        period={churnPeriod}
        chartType={churnChartType}
        onPeriodChange={setChurnPeriod}
        onChartTypeChange={setChurnChartType}
        emptyMessage="No commit data for this member in this window. Link a GitHub contributor to see activity."
      />
    </div>
  );
}
